export const emojiCursor = (emoji: string, baseFontSize = 25, baseCanvasSize = 50, fallbackCursor = 'crosshair') =>
  `url("data:image/svg+xml;utf8, ` +
  `<svg xmlns='http://www.w3.org/2000/svg' ` +
  `width='${baseCanvasSize}' ` +
  `height='${baseCanvasSize}' ` +
  `style='font-size: ${baseFontSize}px'>` +
  `<text dominant-baseline='middle' text-anchor='middle' x='50%' y='50%'>${emoji}</text>` +
  `</svg>` +
  `") ${baseCanvasSize / 2} ${baseCanvasSize / 2}, ${fallbackCursor}`;
